<template>
  <div class="addPurchaseUnit" style="border:1px solid #e0e0e0;">
    <div class="titleForm-container">添加购销单位</div>
    <div class="content-form-container">
      <div class="main-container-form">
        <el-form :model="baseForm" :rules="rules" ref="baseForm" label-width="100px" class="ruleForm">
           <el-form-item label="单位类型" prop="name">
            <el-select v-model="baseForm.type" filterable placeholder="请选择单位类型" size="medium" style="width:100%;" >
              <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="公司名称" prop="name">
            <el-input v-model="baseForm.name" size="medium" style="width:100%;" placeholder="请输入公司全称" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" :maxlength="num50">
            </el-input>
          </el-form-item>
          <el-form-item label="负责人" prop="leader">
            <el-input v-model="baseForm.leader" size="medium" style="width:100%;" placeholder="请输入真实姓名" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" :maxlength="num20">
            </el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="phone">
            <el-input v-model="baseForm.phone" size="medium" style="width:100%;" placeholder="请输入有效联系电话" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" :maxlength="num11">
            </el-input>
          </el-form-item>
           <el-row :gutter="5">
            <el-form-item label="公司地址" required>
              <el-col :span="8">
                <el-form-item prop="areaId">
                  <el-select v-model="baseForm.provinceNo" filterable placeholder="请选择省份" size="medium" style="width:100%;" @change="selectProvince" >
                    <el-option v-for="item in provinces" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="cityNo"  v-if="citys.length>0">
                  <el-select v-model="baseForm.cityNo" filterable placeholder="请选择市" size="medium" style="width:100%;" @change="selectCity">
                    <el-option v-for="item in citys" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="countyNo"  v-if="countys.length>0">
                  <el-select v-model="baseForm.countyNo" filterable placeholder="请选择县" size="medium" style="width:100%;">
                    <el-option v-for="item in countys" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-row>
          <el-form-item label="详细地址" prop="address">
            <el-input v-model="baseForm.address" size="medium" style="width:100%;" type="text" :maxlength="num50" placeholder="详细地址不得少于2个字符" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></el-input>
          </el-form-item>
          <el-form-item label="相关图片" prop="images">
            <el-upload
              style="width:1200px;"
              :action="uploadURl"
              :file-list="fileList"
              list-type="picture-card"
              :with-credentials="true"
              :before-upload="beforeUpload"
              :on-success="handleSuccess"
              :on-remove="handleRemove">
              <i class="el-icon-plus">
                <h4 class="upload-tip">最多上传四张jpg/png图片，且不超过500kb</h4>
              </i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </el-form-item>
          <el-form-item label="营业范围" prop="range">
            <el-input
              type="textarea"
              autosize
              placeholder="请输入公司经营范围"
              v-model="baseForm.range">
            </el-input>
          </el-form-item>
          <el-form-item class="save-cancel">
            <el-col :span="8">
              <el-button class="cancel-btn" @click="cancelForm('baseForm')">取消</el-button>
            </el-col>
            <el-col :span="8">
              <el-button class="save-btn" @click="saveBase('baseForm')" :loading="loadingtype">保存</el-button>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>


<script>
import { mapActions, mapState } from "vuex";
import imgUpload from "../../../service/base-url";
import { modules } from "../../../store";
export default {
  name: "addPurchaseUnit",
  data() {
    return {
      typeList: [
        {
          id: "1",
          name: "销售单位"
        },
        {
          id: "2",
          name: "供货单位"
        },
        {
          id: "3",
          name: "购销单位"
        }
      ],
      dialogImageUrl: "",
      dialogVisible: false,
      num20: 20,
      num11: 11,
      num50: 50,
      citys: [],
      countys: [],
      loadingtype: false,
      index: "",
      defaultImg: [
        {
          name: "food.jpeg",
          url: require("../../../assets/images/qualityTracing/sample_yingyezhizhao1.png")
        }
      ],
      fileList: [],
      // 参数
      baseForm: {
        type: "",
        name: "",
        leader: "", // 联系人
        phone: "",
        provinceNo: "", // 省份
        cityNo: "", // 城市
        countyNo: "", // 辖区
        address: "", // 详细地址
        images: [], //图片
        range: ""
      },
      // 校验规则
      rules: {
        type: [
          {
            required: true,
            message: "请先选择单位类型",
            trigger: "change"
          }
        ],
        name: [
          {
            required: true,
            message: "请先输入公司全称",
            trigger: "blur"
          },
          {
            pattern: /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/,
            message: "公司名称格式不对,请重新输入"
          }
        ],
        leader: [
          { required: true, message: "请先输入真实姓名", trigger: "blur" },
          {
            pattern: /^[a-zA-Z\u4e00-\u9fa5]+$/,
            message: "真实姓名格式不对,请重新输入"
          }
        ],
        phone: [
          { required: true, message: "请先填写联系电话" },
          // { type: "number", message: "联系电话必须为数字" },
          {
            pattern: /^1[3|4|5|7|8|9][0-9]\d{8}$/,
            message: "联系电话格式不对,请重新输入"
          }
        ],
        provinceNo: [
          { required: true, message: "请先选择省份", trigger: "change" }
        ],
        cityNo: [{ required: true, message: "请先选择市", trigger: "change" }],
        countyNo: [
          { required: true, message: "请先选择县", trigger: "change" }
        ],
        address: [
          { required: true, message: "请先输入详细地址", trigger: "blur" }
          // {
          //   pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/,
          //   message: "详细地址格式不对,请重新输入",
          //   min: 2
          // }
        ]
      },
      uploadURl: imgUpload.imgUpload // 文件上传地址
    };
  },
  async mounted() {
    if (this.baseForm.images.length == 0) {
      this.fileList = this.defaultImg;
    }
    this.getProvinces();
    this.baseForm.type = this.typeList[2].id;
    this.initAddress()
  },
  computed: {
    ...mapState(modules.area, {
      provinces: "provinces"
    })
  },
  methods: {
    ...mapActions(modules.circulationBusiness, {
      addCirculationB: "addCirculationB"
    }),
    ...mapActions(modules.area, {
      getProvinces: "getProvinces",
      getArea: "getArea"
    }),
    ...mapActions(['delVisitedViews']),
    //省份获取之后 获取对应的城市
    async selectProvince() {
      let obj = {
        parentNo: this.baseForm.provinceNo
      };
      let result = await this.getArea(obj);
      this.citys = result;
      this.baseForm.cityNo = null;
      this.baseForm.countyNo = null;
      this.countys = [];
    },
    // 城市获取之后 获取对应的县市
    async selectCity() {
      let obj = {
        parentNo: this.baseForm.cityNo
      };
      let result = await this.getArea(obj);
      this.countys = result;
      this.baseForm.countyNo = null;
    },
    judgeImgLength(fileList) {
      if (this.baseForm.images.length == 0) {
        this.fileList = this.defaultImg;
      } else {
        if (fileList.length != this.baseForm.images.length) {
          this.fileList = fileList.splice(1, 1);
        } else {
          this.fileList = fileList;
        }
      }
    },
    // 图片上传之前
    beforeUpload(file) {
      const isImg = file.type === "image/jpeg" || file.type === "image/png";
      const isLt500KB = file.size / 1024 / 1024 < 0.5;
      if (!isImg) {
        this.$message.error("上传图片只能是JPG/png格式!");
        return isImg && isLt500KB;
      }
      if (!isLt500KB) {
        this.$message.error("上传图片大小不能超过500kb!");
        return isImg && isLt500KB;
      }
      if (this.baseForm.images.length >= 4) {
        this.$message({
          message: "最多上传四张图片",
          type: "success"
        });
        return false;
      }
    },
    // 文件上传成功
    handleSuccess(res, file, fileList) {
      this.baseForm.images.push(res.name);
      this.judgeImgLength(fileList);
    },
    // 文件移除
    handleRemove(file, fileList) {
      if (file.id) {
        this.index = this.baseForm.images.indexOf(file.id);
      } else if (file.response) {
        this.index = this.baseForm.images.indexOf(file.response.name);
      } else {
        let urlSlashCount = file.url.split("/").length; // 统计有3斜杠
        let str = file.url.split("/")[urlSlashCount - 1].toLowerCase(); //获取数组最后一个
        this.index = this.baseForm.images.indexOf(str);
      }
      if (this.index != -1) {
        this.baseForm.images.splice(this.index, 1);
        this.judgeImgLength(fileList);
      }
    },
    //保存
    async saveBase(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          // 参数
          let obj = {
            type: this.baseForm.type,
            name: this.baseForm.name,
            leader: this.baseForm.leader,
            phone: this.baseForm.phone,
            areaId:
              this.baseForm.countyNo ||
              this.baseForm.cityNo ||
              this.baseForm.provinceNo || 1,
            address: this.baseForm.address,
            images: this.baseForm.images,
            scope: this.baseForm.range
          };
          this.loadingtype = true;
          // post 请求
          this.addCirculationB(obj)
            .then(data => {
              localStorage.setItem("cacheAddressNo", JSON.stringify({
                provinceNo: this.baseForm.provinceNo,
                cityNo: this.baseForm.cityNo,
                countyNo: this.baseForm.countyNo,
              }));
              this.$message({
                message: "保存成功",
                type: "success"
              });
              this.loadingtype = false;
              this.cancelForm()
            })
            .catch(err => {
              this.$Alert.info({
                content: err.response.data,
                duration: 5000,
                status: "error"
              });
              // this.$message.error(err.response.data);
            });
        } else {
          return false;
        }
      });
    },
    //取消
    cancelForm() {
      this.delVisitedViews([{
        meta: { affix: false },
        path: this.$route.path,
        title: this.$route.meta.title,
      }])
      this.$router.push({ name: "purchaseUnit" });
    },
    async initAddress(){
      let addressNo = JSON.parse(localStorage.getItem('cacheAddressNo'))
      if(addressNo){
        this.baseForm.provinceNo = addressNo.provinceNo
        await this.selectProvince()
        this.baseForm.cityNo = addressNo.cityNo
        await this.selectCity()
        this.baseForm.countyNo = addressNo.countyNo
      }
    }
  }
};
</script>


<style lang="stylus">
.addPurchaseUnit
  .el-input--medium .el-input__inner 
    height: 44px;
    line-height: 44px;
  .el-form
    margin-left:120px;
    .el-form-item .el-form-item__label:before
      position: absolute;
      top: 2px;
      left: 10px;
      color: #fe3223;
    .el-form-item__label
      text-align:right!important;
      font-size:14px!important;
      font-family:MicrosoftYaHei;
      font-weight:400;
      color:rgba(102,102,102,1);
      margin-left:-15px;
  textarea
    font-size:14px;
    font-family:MicrosoftYaHeiUI;
    font-weight:400;
    color:rgba(51,51,51,1);
    min-height:180px !important;
    width: 500px !important
  .el-upload--picture-card
    float left 
    margin-right 10px;
  .el-upload-list--picture-card .el-upload-list__item,.el-upload--picture-card
    width:160px;
    height:148px;
  .el-icon-plus
    position relative
    display block
    width:160px;
    height:148px;
    .upload-tip
      min-width 130px;
      text-align center;
      position absolute;
      top:55%;
      font-size:14px;
      padding:0 15px;
      line-height 1.4;
  .el-icon-plus:before
    position absolute;
    content: "";
    top:30%;
    left:50%;
    margin-top:-24px;
    margin-left:-24px;
    width: 48px;
    height: 48px;
    background: url(../../../assets/images/qualityTracing/input_add.png) no-repeat center center;
    background-size: 48px 48px;
  // .el-select .el-input__inner:nth-child(1)
  //   width:400px;
</style>
